module.exports = __webpack_public_path__ + "img/image29.8d412995.png";